import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { FormControlDesktop } from '@alfalab/core-components-form-control/esm/desktop';
import { BaseInput } from '../components/base-input/Component.js';

var InputDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BaseInput, __assign({}, restProps, { FormControlComponent: FormControlDesktop, ref: ref }))); });

export { InputDesktop };
